import { Injectable } from '@angular/core';

const LAST_SEQ_KEY = 'notes:last_seq';

@Injectable({ providedIn: 'root' })
export class SyncStateService {
  getLastSeq(): string {
    return localStorage.getItem(LAST_SEQ_KEY) ?? '0';
  }

  setLastSeq(seq: string): void {
    localStorage.setItem(LAST_SEQ_KEY, seq);
  }

  clear(): void {
    localStorage.removeItem(LAST_SEQ_KEY);
  }
}